import { useEffect, useState } from 'react';
import {
  Button, Space, App as AntApp, Flex,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';

// Uploader de foto/avatar (FileReader → data URL, max 4MB).
export default function FotoUploader({ fotoAtual, onChange }: { fotoAtual: string; onChange: (url: string) => void }) {
  const { message } = AntApp.useApp();
  const [preview, setPreview] = useState<string>(fotoAtual);
  const [carregando, setCarregando] = useState(false);
  useEffect(() => { setPreview(fotoAtual); }, [fotoAtual]);

  function lerArquivo(file: File) {
    if (file.size > 4 * 1024 * 1024) { message.error('Foto excede 4 MB.'); return; }
    setCarregando(true);
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = String(reader.result);
      setPreview(dataUrl); onChange(dataUrl); setCarregando(false);
    };
    reader.onerror = () => { message.error('Erro ao ler arquivo'); setCarregando(false); };
    reader.readAsDataURL(file);
  }

  return (
    <Flex align="center" gap={14}>
      {preview
        ? <img src={preview} alt="" style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', border: '1px solid #ddd' }} />
        : <div style={{ width: 80, height: 80, borderRadius: '50%', background: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa', fontSize: 28 }}>?</div>}
      <Space direction="vertical" size={4}>
        <Button type="primary" ghost size="small" icon={<UploadOutlined />} loading={carregando}>
          <label style={{ cursor: 'pointer' }}>
            {preview ? 'Trocar foto' : 'Escolher foto'}
            <input type="file" accept="image/png,image/jpeg,image/webp" style={{ display: 'none' }}
              onChange={(e) => { const f = e.target.files?.[0]; if (f) lerArquivo(f); }} />
          </label>
        </Button>
        {preview && (
          <Button type="link" size="small" danger onClick={() => { setPreview(''); onChange(''); }}>
            🗑 Remover
          </Button>
        )}
      </Space>
    </Flex>
  );
}
